import type { Entities_Player_ProgressSummary_Response } from '@suntex.fim/api-client';

import { InfoPane } from '../display/InfoPane';
import { Radial } from '../display/Radial';
import { StarValue } from '../types';

import { computeModuleProgress } from './computeStarValue';

export function applyProgress(
  rootRadial: Radial,
  progressSummary: Entities_Player_ProgressSummary_Response,
  goldStarInfoPane: InfoPane,
): void {
  applyToRadial(rootRadial);

  // Recursively apply starring to all descendants
  function applyToRadial(radial: Radial): StarValue {
    let star: StarValue;
    let progress: number;

    // If this radial has children, recurse
    if (radial.radialChildren.length > 0) {
      let goldStarCount = 0;
      let silverStarCount = 0;
      let totalCount = 0;

      for (const child of radial.radialChildren.filter((r) => r.inFocus)) {
        const childStar = applyToRadial(child);
        totalCount++;
        if (childStar === StarValue.Gold) {
          goldStarCount++;
          silverStarCount++;
        } else if (childStar === StarValue.Silver) {
          silverStarCount++;
        }
      }

      if (goldStarCount > 0 && radial.infoPane == null) {
        radial.setInfoPane(goldStarInfoPane);
      } else if (goldStarCount === 0 && radial.infoPane === goldStarInfoPane) {
        radial.setInfoPane(null);
      }

      if (goldStarCount === totalCount) {
        star = StarValue.Gold;
        progress = StarValue.Gold;
      } else if (silverStarCount === totalCount) {
        star = StarValue.Silver;
        progress = StarValue.Silver + goldStarCount / totalCount;
      } else {
        star = StarValue.None;
        progress = silverStarCount / totalCount;
      }
    } else {
      // Leaf node - compute fractional progress for animation, derive star from it
      progress = computeModuleProgress(progressSummary, radial);
      star = Math.floor(progress);
    }

    radial.showProgress(progress);
    return star;
  }
}
